import {
    toggleOpinionForm,
    toggleView,
    getCurrentKey
} from "./functions";

import mapbox from '../mapbox-settings'

/**
 * Description: Shows info window on map when toggled
 * value - answer_question in DB - Model PHP Project\Answer
 * @return {Void}
 */
const showOnMap = function(value) {

    toggleOpinionForm(value)

    if (getCurrentKey() === "listing") {
        toggleView("normal");
    }

};

const mapBoxFilter = function( values, incomingGoodOptions, incomingBadOptions ) {

    const goodToggle = values.find(option => option.type === 'good_bad' && option.value === 'good') ? true : false

    const badToggle = values.find(option => option.type === 'good_bad' && option.value === 'bad') ? true : false

    const ages = values.filter(option => option.type === 'age')

    const genders = values.filter(option => option.type === 'sex')

    const types = values.filter(option => option.type === 'type')

    const counties = values.filter(option => option.type === 'county')

    const qualities = values.filter(option => option.type === 'quality')

    const deeplink = values.filter(option => option.type === 'deeplink')

    const images = values.filter(option => option.type === 'only_images')

    let filters = ['all']

    let agesArray = [], gendersArray = [], typesArray = [], countyArray = [], goodBadArray = [], goodArray = [], badArray = [], deepLinkArray = [], imagesArray = []

    for (const item of ages) {
        agesArray.push(['==', 'age', item.value])
    }

    if( agesArray.length ) {
        filters.push(['any'].concat(agesArray))
    }

    for (const item of genders) {
        gendersArray.push(['==', 'sex', item.value])
    }

    if( gendersArray.length ) {
        filters.push(['any'].concat(gendersArray))
    }

    for (const item of types) {
        typesArray.push(['==', 'type', item.value])
    }

    if( typesArray.length ) {
        filters.push(['any'].concat(typesArray))
    }

    for (const item of counties) {
        countyArray.push(['==', 'county', item.value])
    }

    if( countyArray.length ) {
        filters.push(['any'].concat(countyArray))
    }

    for (const item of deeplink) {
        deepLinkArray.push(['==', 'deep_link', item.value])
    }

    if( deepLinkArray.length ) {
        filters.push(['any'].concat(deepLinkArray))
    }

    for (const item of images) {
        imagesArray.push(['==', 'only_images', item.value])
    }

    if( imagesArray.length ) {
        filters.push(['any'].concat(imagesArray))
    }

    let showGoodSub = false, showBadSub = false, showGood = false, showBad = false, showAll = false

    let goodBadFilters = []

    if( qualities.length ) {

        for (const item of qualities) {

            if( incomingGoodOptions.includes( item.value ) ) {
                goodArray.push(item.value)
            }

            if( incomingBadOptions.includes( item.value ) ) {
                badArray.push(item.value)
            }

        }

    }

    if( ( ! goodToggle && ! badToggle && goodArray.length && ! badArray.length  ) ) {
        // visa bara bra undernivå
        // console.log('visa bara BRA undernivå')
        showGoodSub = true
    }

    else if( ( ! goodToggle && ! badToggle && ! goodArray.length && badArray.length  ) ) {
        // visa bara bra undernivå
        // console.log('visa bara DÅLIG undernivå')
        showBadSub = true
    }

    else if( ( goodToggle && ! badToggle && ( goodArray.length || badArray.length  ) ) ) {
        // visa bara bra undernivå
        // console.log('visa bara BRA undernivå')
        showGoodSub = true
    }

    else if( ( badToggle && ! goodToggle && ( goodArray.length || badArray.length ) ) ) {
        // visa bara dåliga undernivå
        // console.log('visa bara DÅLIG undernivå')
        showBadSub = true
    }

    else if( ( goodToggle && goodArray.length && ! badArray.length ) ) {
        // bra + undervariant visa bara undervariant
        // console.log('visa bara BRA undernivå')
        showGoodSub = true
    }

    else if( ( badToggle && ! goodArray.length && badArray.length ) ) {
        // dålig + undervariant visa bara undervariant
        // console.log('visa bara DÅLIG undernivå')
        showBadSub = true
    }

    else if( ( goodToggle && ! badToggle ) && ! goodArray.length && ! badArray.length ) {
        //visa bara bra
        // console.log('visa alla BRA')
        showGood = true
    }

    else if( ( badToggle && ! goodToggle ) && ! goodArray.length && ! badArray.length ) {
        //visa bara dåliga
        // console.log('visa alla DÅLIG')
        showBad = true
    }

    else if( goodToggle && badToggle && goodArray.length && badArray.length ) {
        // console.log('visa BRA undernivå & visa DÅLIG undernivå')
        showGoodSub = true
        showBadSub = true
    }

    else if( goodArray.length && badArray.length ) {
        // console.log('visa BRA undernivå & visa DÅLIG undernivå')
        showGoodSub = true
        showBadSub = true
    }

    else {
        if( ! showGood && ! showBad && ! showGoodSub && ! showBadSub ) {
            // console.log('visa alla')
            showAll = true
        }
    }

    if( qualities.length ) {

        for (const item of qualities) {

            if( incomingGoodOptions.includes( item.value ) && showGoodSub ) {
                goodBadFilters.push( ['==', 'good_option_' + item.value, true] )
            }

            if( incomingBadOptions.includes( item.value ) && showBadSub ) {
                goodBadFilters.push( ['==', 'bad_option_' + item.value, true] )
            }

        }

    }

    if( showGood && ! showBad && ! showAll ) {
        // for ( const id of incomingGoodOptions ) {
        //     goodBadFilters.push( ['==', 'good_option_' + id, true] )
        // }
        goodBadFilters.push( ['==', 'value_type', 'good'] )
    }

    if( showBad && ! showGood && ! showAll ) {
        // for (const id of incomingBadOptions) {
        //     goodBadFilters.push( ['==', 'bad_option_' + id, true] )
        // }
        goodBadFilters.push( ['==', 'value_type', 'bad'] )
    }

    if( ! showBad && ! showGood && showAll ) {
        goodBadFilters.push( ['==', 'value_type', 'good'] )
        goodBadFilters.push( ['==', 'value_type', 'bad'] )
    }

    if( goodBadFilters.length ) {
        filters.push(['any'].concat( goodBadFilters ))
    }

    return filters


}


const getThumbnailMapbox = function(slide) {
    // https://docs.mapbox.com/playground/static/
    return `https://api.mapbox.com/styles/v1/mapbox/satellite-v9/static/${slide.center_lng},${slide.center_lat},11,0/120x120?access_token=${mapbox.accessToken}`
}


export { showOnMap, mapBoxFilter, getThumbnailMapbox };
